import { KontoausgleicheArt } from '@/domain/mitarbeiter/features/feiertagskonto/entities';
import { Badge } from '@e2n/ui/v2';
import {
  faCalendarCircleMinus,
  faCalendarCirclePlus,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function KontausgleichArtBadge({ art }: { art: KontoausgleicheArt }) {
  return art === KontoausgleicheArt.FEIERTAGSAUSZAHLUNG ? (
    <Badge shape="rectangle">
      <FontAwesomeIcon
        icon={faCalendarCircleMinus}
        className="text-secondary-purple-500"
      />
      {art}
    </Badge>
  ) : (
    <Badge shape="rectangle">
      <FontAwesomeIcon
        icon={faCalendarCirclePlus}
        className="text-brand-red-200"
      />
      {art}
    </Badge>
  );
}
